
import {PulseSearch} from 'components/pulse'
import {groupSkills} from './commands-menu-defs'

export default {
  components: {PulseSearch},
  props: {
    disabled: {type: Boolean, default: false},
    skills: {type: Array, required: true},
    sources: {type: Array, required: true},
  },
  emits: ['source', 'skill'],
  data() {
    return {
      visible: false,
      search: '',
      open_groups: {},
    }
  },
  computed: {
    normalized_search() {
      return (this.search || '').trim().toLowerCase()
    },
    has_search() {
      return !!this.normalized_search
    },
    has_results() {
      return this.filtered_skills.length > 0 || this.filtered_sources.length > 0
    },
    filtered_skills() {
      return this.skills.filter(item => this.matchesSearch(item))
    },
    filtered_sources() {
      return this.sources.filter(item => this.matchesSearch(item))
    },
    skill_groups() {
      return groupSkills(this.filtered_skills)
    }
  },
  methods: {
    clearSearch() {
      this.search = ''
    },
    matchesSearch(item) {
      const search = this.normalized_search
      return !search || [item.title, item.command].some(value => value?.toLowerCase().includes(search))
    },
    selectSkill(command) {
      this.$emit('skill', command)
      this.close()
    },
    selectSource(command) {
      this.$emit('source', command)
      this.close()
    },
    toggleGroup(category) {
      this.open_groups[category] = !this.open_groups[category]
    },
    close() {
      this.visible = false
    }
  }
}
